import { Box } from "src/components/MuiGenerals";
import OverflowTooltipText from "src/components/OverflowTooltipText";
import { useBatchApproveAllowancePreviewContext } from "src/views/AssetManagement/BatchApproveAllowance/contexts";

function Summary() {
  const {
    summaryDetails: {
      addressesSummary: { totalCount, selectedCount },
      chainName,
      currency,
      spenderAddress,
    },
    translate: t,
  } = useBatchApproveAllowancePreviewContext();

  return (
    <Box
      sx={{
        padding: "1rem",
        display: "grid",
        gridTemplateColumns:
          "minmax(max-content, 5rem) auto minmax(max-content, 5rem) auto minmax(max-content, 5rem) auto",
        gap: "2rem",
        marginBottom: "16px",
        backgroundColor: "#eee",

        "div:nth-of-type(odd)": {
          fontWeight: "500",
        },
        "div:nth-of-type(even)": {
          color: "#4a90f7",
        },
      }}>
      <div>
        {t("chain_name")} / {t("currency")}
      </div>
      <OverflowTooltipText text={`${chainName} / ${currency}`} />
      <div>{t("spender_address")}</div>
      <OverflowTooltipText text={spenderAddress} copyable />
      <div>{t("max_selectable_addresses")}</div>
      <OverflowTooltipText text={totalCount} />
      <div>{t("selected_addresses")}</div>
      <OverflowTooltipText text={selectedCount} />
    </Box>
  );
}

export default Summary;
